<template>
    <div class="search-area">
        <div  style="padding:8px 0px; display: flex;align-items: center; ">

           <el-form class="demo-form-inline" style="width:100%;">
                <div style="width:100%;display:flex;align-items: center;">
                    <div style="width:70%;display:flex;align-items: center; justify-content: flex-start; ">
                        <div class="input-group-search" >
                          <el-input 
                            id="name" 
                            v-model="searchParam.name" 
                            class="input-field" 
                            clearable 
                            style="width:260px;" 
                            placeholder=" " 
                          />
                          <label for="name" class="floating-label">姓名或者昵称</label>
                        </div>
                        <div class="input-group-search">
                          <el-input type="text" id="phone" v-model="searchParam.phone" class="input-field" clearable style="width:260px;" placeholder=" " />
                          <label for="phone" class="floating-label">手机号</label>
                        </div>
                          <div class="input-group" style="width: 260px;" :class="{ 'has-value': searchParam.pushStatus !== '' }">
                            <el-select
                              v-model="searchParam.pushStatus" 
                              id="loginAccount1"
                              class="select-field"
                              style="width:260px;"
                              clearable
                              placeholder=" "
                            >
                              <el-option
                                v-for="item in pushStatusOpt"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                            <label for="loginAccount1" class="floating-label1">发布状态</label>
                          </div>

                    </div>
                    <div style="width:30%;text-align:right; font-size: 24px; cursor: pointer;">

                        <el-tooltip class="item" effect="dark"  content="新增" placement="bottom">
                            <i class="el-icon-plus" @click="addOpenDrawer" ></i>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark"  content="刷新" placement="bottom">
                            <i class="el-icon-refresh" @click="getPage" ></i>
                        </el-tooltip>

                    </div>

                </div>

            </el-form>

        </div>
    
       
       <el-table class="table-data" :data="tableData" :height="tableHeight"  style="width:100%; margin-bottom: 10px; ">

            <el-table-column
                    prop="userId"
                    label="自增Id"
                     width="120">
            </el-table-column>
            <el-table-column
                    prop="nickName"
                    label="昵称"
                    width="150"
                    >
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="姓名"
                    width="150"
                    >
            </el-table-column>
            <el-table-column
                    prop="phone"
                    label="手机号"
                    width="150"
                    >
            </el-table-column>
            <el-table-column
                    prop="sex"
                    label="性别"
                    width="150"
                    >
            </el-table-column>
             <el-table-column
                    prop="marriageStatus"
                    label="婚姻情况"
                    width="150"
                    >
            </el-table-column>
             <el-table-column
                    prop="msgStatus"
                    label="发言状态"
                    width="150"
                    >
            </el-table-column>
             <el-table-column
                    prop="pushStatus"
                    label="发布状态"
                    width="150"
                    >
            </el-table-column>
            <el-table-column
                    prop="level"
                    label="优质等级"
                    width="150"
                    >
            </el-table-column>

            <el-table-column
                    prop="createTime"
                    label="创建时间"
                     width="200"
                   >
            </el-table-column>
            <el-table-column
                    prop="lastUpdateTime"
                    label="最后修改时间"
                     width="200"
                   >
            </el-table-column>
            <el-table-column
                    label="操作"
                    fixed="right"
                    width="200"
                    >
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="查看详情" placement="bottom">
                        <i class="el-icon-edit table-btn-icon" @click="getId(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="关注人数" placement="bottom">
                        <i class="el-icon-star-on table-btn-icon" @click="openStarDrawer(scope.row,0)">{{scope.row.interestTotal}}</i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="被关注人数" placement="bottom">
                        <i class="el-icon-star-off table-btn-icon" @click="openStarDrawer(scope.row,1)">{{scope.row.beInterestTotal}}</i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
      
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                @next-click="nextClick"
                @prev-click="prevClick"
                :current-page="pageUtil.curPage"
                :page-sizes="[20, 30, 50, 100,200]"
                :page-size="pageUtil.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageUtil.total"
                style="height: 30px; line-height: 30px; margin:10px auto; text-align: center;">
        </el-pagination>
        
        <el-drawer
          title="编辑"
          :visible.sync="isOpenDrawer"
          :wrapperClosable="false"
          direction="rtl"
          :before-close="handleClose">
           <!-- 使用flex布局确保底部固定 -->
          <div class="drawer-container">
            <!-- 可滚动的内容区域 -->
            <div class="drawer-content">
              <!-- <span>我来啦!</span> -->
              <!-- 这里可以放置您的表单或其他内容 -->
              <!-- <div style="height: 1500px; background: #f5f5f5; margin-top: 20px;">
                模拟长内容区域
              </div> -->

              <el-form :model="user" ref="baseForm" :rules="rules" >

                <div class="input-group" >
                  <el-form-item prop="nickName" >
                       <el-input type="text" id="nickName" v-model="user.nickName" class="input-field" placeholder=" " />
                        <label for="nickName" class="floating-label">* 用户昵称</label>
                  </el-form-item>
                </div>

                <div class="input-group" >
                  <el-form-item prop="name" >
                       <el-input type="text" id="name" v-model="user.name" class="input-field" placeholder=" " />
                        <label for="name" class="floating-label">* 姓名</label>
                  </el-form-item>
                </div>

                <div class="input-group" >
                  <el-form-item prop="phone" >
                       <el-input type="text" id="phone" v-model="user.phone" class="input-field" placeholder=" " />
                        <label for="phone" class="floating-label">* 手机号</label>
                  </el-form-item>
                </div>

                <div class="input-group" >
                  <el-form-item prop="contactNumber" >
                       <el-input type="text" id="contactNumber" v-model="user.contactNumber" class="input-field" placeholder=" " />
                        <label for="contactNumber" class="floating-label">* 联系人</label>
                  </el-form-item>
                </div>

                <div class="input-group" >
                  <el-form-item prop="birthday"  >
                       <el-date-picker
                       style="width:100%;"
                        v-model="user.birthday"
                        type="date"
                        format="yyyy/MM/dd"
                        placeholder="* 生日">
                      </el-date-picker>

                        <!-- <label for="birthday" class="floating-label">生日</label> -->
                  </el-form-item>
                </div>

                <el-form-item label="* 性别">
                    <el-radio-group v-model="user.sex">
                      <el-radio :label="0">未知</el-radio>
                      <el-radio :label="1">男</el-radio>
                      <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                  </el-form-item>

                <div class="input-group m-top20" :class="{ 'has-value': user.provinceId !== '' }">
                  <el-form-item prop="provinceId" >
                    <el-select
                      v-model="user.provinceId" 
                      id="provinceId"
                      class="select-field"
                      clearable
                      @change="changeCity(2)"
                      placeholder=" "
                    >
                      <el-option
                        v-for="item in listProvince"
                        :key="item.id"
                        :label="item.cityName"
                        :value="item.id"
                      >
                      </el-option>
                     </el-select>
                     <label for="provinceId" class="floating-label1" style="border:0px;">* 所属省份</label>
                   </el-form-item>
                </div>

               <div class="input-group m-top20" :class="{ 'has-value': user.cityId !== '' }">
                 <el-form-item prop="cityId" >
                    <el-select
                      v-model="user.cityId" 
                      id="cityId"
                      class="select-field"
                      clearable
                      @change="changeCity(3)"
                      placeholder=" "
                    >
                      <el-option
                        v-for="item in listCity"
                        :key="item.id"
                        :label="item.cityName"
                        :value="item.id"
                      >
                      </el-option>
                     </el-select>
                     <label for="provinceId" class="floating-label1" style="border:0px;">* 所属城市</label>
                   </el-form-item>
                </div>

                 <div class="input-group m-top20" :class="{ 'has-value': user.countyId !== '' }">
                  <el-form-item prop="countyId" >
                    <el-select
                      v-model="user.countyId" 
                      id="countyId"
                      class="select-field"
                      clearable
                      placeholder=" "
                    >
                      <el-option
                        v-for="item in listCounty"
                        :key="item.id"
                        :label="item.cityName"
                        :value="item.id"
                      >
                      </el-option>
                     </el-select>
                     <label for="countyId" class="floating-label1" style="border:0px;">* 所属区县</label>
                  </el-form-item>
                </div>

               

                 <el-form-item label="* 婚姻情况" prop="marriageStatus"  class="m-top20">
                    <el-radio-group v-model="user.marriageStatus">
                      <el-radio :label="0">未知</el-radio>
                      <el-radio :label="1">单身</el-radio>
                      <el-radio :label="2">未婚</el-radio>
                      <el-radio :label="3">离异</el-radio>
                      <el-radio :label="4">离异带娃</el-radio>
                    </el-radio-group>
                  </el-form-item>

                <div class="input-group m-top20" :class="{ 'has-value': user.pushStatus !== '' }" v-if="optBtnStatus=='update'">
                   <el-form-item prop="msgStatus" >
                    <el-select
                      v-model="user.msgStatus" 
                      id="msgStatus"
                      class="select-field"
                      clearable
                      placeholder=" "
                    >
                      <el-option
                        v-for="item in msgStatusOpt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                     </el-select>
                     <label for="msgStatus" class="floating-label1" style="border:0px;">* 发言状态</label>
                    </el-form-item>
                </div>

                 <div class="input-group m-top20" :class="{ 'has-value': user.pushStatus !== '' }" v-if="optBtnStatus=='update'">
                  <el-form-item prop="pushStatus" >
                    <el-select
                      v-model="user.pushStatus" 
                      id="pushStatus"
                      class="select-field"
                      disabled="false"
                      clearable
                      placeholder=" "
                    >
                      <el-option
                        v-for="item in pushStatusOpt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                     </el-select>
                     <label for="pushStatus" class="floating-label1" style="border:0px;">* 发布状态</label>
                    </el-form-item>
                </div>

                 <div class="input-group m-top20" :class="{ 'has-value': user.level !== '' }">
                  <el-form-item prop="level" >
                    <el-select
                      v-model="user.level" 
                      id="level"
                      class="select-field"
                      clearable
                      placeholder=" "
                    >
                      <el-option
                        v-for="item in levelOpt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                     </el-select>
                     <label for="level" class="floating-label1" style="border:0px;">* 优质等级</label>
                  </el-form-item>
                </div>

                <div class="input-group m-top20">
                  <el-form-item prop="introContent" >
                      <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="* 个人介绍"
                      v-model="user.introContent">
                    </el-input>
                       
                  </el-form-item>
                </div>
                <div>

                <div class="input-group" v-if="optBtnStatus=='update'" >
                  <el-form-item prop="createTime" >
                       <el-input type="text" id="createTime" v-model="user.createTime" disabled="false" class="input-field" placeholder=" " />
                        <label for="createTime" class="floating-label">创建时间</label>
                  </el-form-item>
                </div>

                <div class="input-group" v-if="optBtnStatus=='update'">
                  <el-form-item prop="lastUpdateTime" >
                       <el-input type="text" id="lastUpdateTime" v-model="user.lastUpdateTime" disabled="false" class="input-field" placeholder=" " />
                        <label for="lastUpdateTime" class="floating-label">最后修改时间</label>
                  </el-form-item>
                </div>

               <el-row >
                  <div style="display: flex;flex-wrap: wrap; justify-content: space-between;">

                     <el-col :span="10" v-for="(item, index) in user.userPhotoList" :key="o" style=" width: 150px;">
                    <el-card :body-style="{ padding: '0px' }"  style="margin-top:15px;margin-right:15px;width: 150px;">
                      <el-image :src="imgUrl+item.imgPath" :preview-src-list="srcList"  class="image fixed-image"/>
                      <div style="padding-left: 6px;">
                        <div class="bottom clearfix">
                          <el-button type="text" class="button" @click="deleteImage(index)">删除</el-button>
                        </div>
                      </div>
                    </el-card>
                  </el-col>

                  </div>
                 
                </el-row>
                    <el-upload
                    ref="uploadPhoto"
                    class="m-top20"
                    :action="uploadUrl"
                    :headers="headers"
                    :multiple="true"
                    name="files" 
                    accept="image/*"
                    list-type="picture-card"
                    :on-success="uploadSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>

                </div>
                
               
              </el-form>


            </div>
            
            <!-- 固定的底部按钮区域 -->
            <div class="drawer-footer">
              <!-- <el-button @click="handleClose">取消</el-button>-->
              <el-button type="danger" @click="optPushNotIssue" v-if="optBtnStatus=='update'">{{optBtnInfo.text}}</el-button>
              <el-button type="primary" @click="save">保存</el-button> 
            </div>
          </div>

        </el-drawer>
           <!-- 显示用户列表 -->
         <el-drawer
          title="查看"
          :visible.sync="isOpenStarDrawer"
          :wrapperClosable="false"
          direction="rtl"
          :before-close="false">
           <!-- 使用flex布局确保底部固定 -->
          <div class="drawer-container">
            <!-- 可滚动的内容区域 -->
            <div class="drawer-content" >
              <!-- <span>我来啦!</span> -->
              <!-- 这里可以放置您的表单或其他内容 -->
              <!-- <div style="height: 1500px; background: #f5f5f5; margin-top: 20px;">
                模拟长内容区域
              </div> -->

              <div style="display: flex;  margin-top:15px;" v-for="item in interestData">
                <div>
                  <el-avatar :src="item.imgHeadUrl"></el-avatar>
                </div>
                <div style="margin-left:10px;">
                    <div style="color: #000;font-size: 14px;">{{item.nickName}}</div>
                    <div style="font-size: 12px;">{{item.introContent}}</div>
                </div>
              </div>

               <!-- <div style="display: flex; margin-top:15px;">
                <div>
                  <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
                </div>
                <div style="margin-left:10px;">
                    <div style="color: #000;font-size: 14px;">张三</div>
                    <div style="font-size: 12px;">这个是张三的个人简介</div>
                </div>
              </div> -->
              
            </div>
            
            <!-- 固定的底部按钮区域 -->
            <div class="drawer-footer">
               <el-pagination
                @size-change="interestHandleSizeChange"
                @current-change="interestHandleCurrentChange"
                @next-click="interestNextClick"
                @prev-click="interestPrevClick"
                :current-page.sync="interestPageUtil.curPage"
                :page-size="interestPageUtil.pageSize"
                layout="total, prev, pager, next"
                :total="interestPageUtil.total">
               </el-pagination>
            </div>
          </div>

        </el-drawer>


     </div>

     
  </template>

<script>



  var _this;
export default {
  name: 'Role',
  data () {
    return {
      tableHeight: 200,
      pageUtil:{total:0,pageSize:20,curPage:1},
      interestPageUtil:{total:0,pageSize:20,curPage:1},
      interestData:[],
      tableData:[],
      searchParam:{
          pushStatus: '',
          name: '',
          phone: '',
      }, sexOpt: [
         { value: 0, label: '未知'},
         { value: 1, label: '男'},
         { value: 2, label: '女'}
      ], marriageStatusOpt: [
         { value: 0, label: '未知'},
         { value: 1, label: '单身'},
         { value: 2, label: '未婚'},
         { value: 3, label: '离异'},
         { value: 4, label: '离异带娃'}
      ],
       pushStatusOpt: [
         { value: 0, label: '未发布'},
         { value: 1, label: '待审核'},
         { value: 2, label: '审核打回'},
         { value: 3, label: '已发布'}
      ],msgStatusOpt:[
         { value: 0, label: '正常'},
         { value: 1, label: '禁言'},

      ],levelOpt: [
         { value: 0, label: '0'},
         { value: 1, label: '1'},
         { value: 2, label: '2'},
         { value: 3, label: '3'},
         { value: 4, label: '4'},
         { value: 5, label: '5'}
      ],
      isOpenDrawer:false,
      optBtnStatus:'',
      optBtnInfo:{},
      user:{sex:'',provinceId:'',cityId:'',countyId:'',marriageStatus:'',pushStatus:'',level:'',introContent:'',photoImgPath:[]},
      listProvince:[],
      listCity:[],
      listCounty:[],
      dialogImageUrl: '',
      srcList:[],
      dialogVisible: false,
      uploadUrl:'',
      imgUrl:'',
      headers: {
        'auth-token':''
      },rules: {
       nickName: [
        { required: true, message: '请输入昵称', trigger: 'blur' },
        { min: 2, max: 64, message: '长度在 2 到 64 个字符', trigger: 'blur' }
      ],phone: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { min: 11, max: 11, message: '长度在11个字符', trigger: 'blur' }
      ],
      contactNumber:[
         { required: true, message: '请输入联系人', trigger: 'blur' },
        { min: 11, max: 11, message: '长度在11个字符', trigger: 'blur' }
      ],
      name: [
        { required: true, message: '请输入姓名', trigger: 'blur' },
        { min: 2, max: 16, message: '长度在 2 到 16 个字符', trigger: 'blur' }
      ],birthday: [
        { required: true, message: '请输入生日', trigger: 'blur' } 
      ],
      sex: [
        { required: true, message: '请输入性别', trigger: 'blur' }
      ],
      provinceId: [
         { required: true, message: '请输入省份', trigger: 'blur' },
      ],cityId: [
         { required: true, message: '请输入城市', trigger: 'blur' },
      ],countyId: [
         { required: true, message: '请输入区县', trigger: 'blur' },
      ],marriageStatus: [
         { required: true, message: '请输入婚姻状态', trigger: 'blur' },
      ],level: [
         { required: true, message: '请输入等级', trigger: 'blur' },
      ],introContent:[
         { required: true, message: '请输入个人简介', trigger: 'blur' },
      ]
      },isOpenStarDrawer:false
    }
  }, mounted(){
     
    //_this.initContentHeight(_this);
      _this.$com.initContentHeight(_this);
      _this.getPage();
      let apiUrl = _this.$com.getApiUrl();
      _this.imgUrl = _this.$com.getImageUrl();
      _this.uploadUrl = apiUrl+'/back_bin/user/array_file_upload';
      
      _this.headers['auth-token'] = this.$http.getAuthToken();
      
        //_this.menuurl = `${process.env.PAGE_URL_PREFIX}`+"#/menu_main";
        //alert("test:"+bodyHeight);

  },created: function () {
      _this = this;
     
  },methods:{
     // 上传成功
    uploadSuccess(response, file) {
      // 处理上传成功的逻辑
      console.log('上传成功:', response);
      let photoImgPath = _this.user.photoImgPath || [];

      let resultUrlArray = response.data;
      for(let i=0;i<resultUrlArray.length;i++){

          photoImgPath.push(resultUrlArray[i]);

      }
      
       _this.user.photoImgPath = photoImgPath;
      // 如果需要，可以更新file的url
      // file.url = response.data.url;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
     getPage(){

       try {
        
            var param = _this.searchParam;
           
            param['pageSize'] = _this.pageUtil.pageSize;
            param['curPager'] = _this.pageUtil.curPage;
            
            _this.$http.get('/back_bin/user/get_page', param,(response)=>{

            _this.pageUtil.total = response.data.countSum;
            _this.pageUtil.curPage = response.data.curPager;
            let list = response.data.list;
            if(list!=null && list.length > 0){

              for(let i=0;i<list.length;i++){

                let bean = list[i];
                bean.createTime = _this.$com.dateConvertTime(bean.createTime);
                bean.lastUpdateTime = _this.$com.dateConvertTime(bean.lastUpdateTime);

                if(bean.sex == 0){
                   bean.sex = '未知';
                }else if(bean.sex == 1){
                   bean.sex = '男生';
                }else if(bean.sex == 2){
                   bean.sex = '女生';
                }

                if(bean.marriageStatus == 0){
                   bean.marriageStatus = '未知';
                }else if(bean.marriageStatus == 1){
                   bean.marriageStatus = '单身';
                }else if(bean.marriageStatus == 2){
                   bean.marriageStatus = '未婚';
                }else if(bean.marriageStatus == 3){
                   bean.marriageStatus = '离异';
                }else if(bean.marriageStatus == 4){
                   bean.marriageStatus = '离异带娃';
                }

                if(bean.msgStatus == 0){
                   bean.msgStatus = '正常';
                }else if(bean.msgStatus == 1){
                   bean.msgStatus = '禁言';
                }

                if(bean.pushStatus == 0){
                   bean.pushStatus = '未发布';
                }else if(bean.pushStatus == 1){
                   bean.pushStatus = '待审核';
                }else if(bean.pushStatus == 2){
                   bean.pushStatus = '审核打回';
                }else if(bean.pushStatus == 3){
                   bean.pushStatus = '已发布';
                }

              }

            }
            
            _this.tableData = list;
             console.info('请求结果1:', response )
            if(response .status == 'success'){


            }

            });
           
          } catch (error) {
            console.error('请求失败:', error)
          }


        },nextClick:function(){

            _this.pageUtil.curPage = _this.pageUtil.curPage+1;
            _this.getPage();

        },prevClick:function(){

            _this.pageUtil.curPage = _this.pageUtil.curPage-1;
            _this.getPage();

        },handleSizeChange:function(val) {

            _this.pageUtil.pageSize = val;

        },handleCurrentChange:function(val) {

            //console.log(`当前页: ${val}`);
            _this.pageUtil.curPage = val;
            _this.getPage();

        },addOpenDrawer:function(){
            
          _this.optBtnStatus = 'add';
           _this.resetForm();
           _this.isOpenDrawer = true;
           _this.getListCity(1,-1,'');

        },handleClose:function(){

          _this.isOpenDrawer = false;

        }, async getListCity(level,parentId,cityName){

         try {
             

            var param = {};
            //=1&=-1&cityName=
            param['level'] = level;
            param['parentId'] = parentId;
            param['cityName'] = cityName;
            
            const response = await _this.$http.syncGet('/back_bin/city/get_list_city', param);
            
            let list = response.data;
            if(level ==1){

                _this.listProvince = list;
            }else if(level == 2){
                _this.listCity = list;
            }else if(level == 3){
                _this.listCounty = list;
            }
             
             console.info('请求结果1:', response )
           
          } catch (error) {
            console.error('请求失败:', error)
          }

        },changeCity:function(level){

          let parentId = 0;
          if(level ==2){
                parentId = _this.user.provinceId;;
          }else if(level == 3){
                parentId =  _this.user.cityId;
          }
           
          _this.getListCity(level,parentId,'');


        },save(){

            if(_this.optBtnStatus == 'add'){
              _this.add();
            }else if(_this.optBtnStatus == 'update'){
               _this.update();
            }

        },async add(){

           try {
             
             // 先验证表单
            const isValid = await this.$refs.baseForm.validate();
            
              if (isValid) {

                var param = _this.user;
               param.birthday = _this.$com.formatDate(param.birthday);
               const response = await _this.$http.syncPost('/back_bin/user/add', param);
               if(response.status == 'success'){

                  _this.isOpenDrawer = false;
                  _this.$message({
                    message: '新增成功!',
                    type: 'success'
                  });

                  _this.getPage();

               }
               console.info('请求结果1:', response )

              }else{
                console.error('校验失败');
              }
              
            
            } catch (error) {
              console.error('请求失败:', error)
            }

        },async update(){

           try {
             
              // 先验证表单
             const isValid = await this.$refs.baseForm.validate();
            
             if (isValid) {

                var param = _this.user;
                param.birthday = _this.$com.formatDate(param.birthday);
                const response = await _this.$http.syncPost('/back_bin/user/update', param);
                if(response.status == 'success'){

                    _this.isOpenDrawer = false;
                    _this.$message({
                      message: '修改成功!',
                      type: 'success'
                    });

                    _this.getPage();

                }
                console.info('请求结果1:', response )

             }
              
            
            } catch (error) {
              console.error('请求失败:', error)
            }

        },async getId(row){

           try {
              _this.optBtnStatus = 'update';
              _this.resetForm();
              var param = {'keyId':row.userId};
              
              const response = await _this.$http.syncGet('/back_bin/user/get_by_id', param);
              if(response.status == 'success'){
                
                  _this.isOpenDrawer = true;
                   let user = response.data;
                  _this.getListCity(1,-1,'');
                  _this.getListCity(2,user.provinceId,'');
                  _this.getListCity(3,user.cityId,'');
                 user.createTime = _this.$com.dateConvertTime(user.createTime);
                 user.lastUpdateTime = _this.$com.dateConvertTime(user.lastUpdateTime);
                 
                  user.birthday = _this.$com.dateConvertDate(user.birthday);

                  if(user.userPhotoList != null && user.userPhotoList.length > 0){
                    let srcList = [];
                    for(let key in user.userPhotoList){

                      const photo = user.userPhotoList[key];
                      srcList.push(_this.imgUrl+photo.imgPath); 


                    }

                    _this.srcList = srcList;

                  }

                  let optBtnInfo = _this.optBtnInfo;
                  if(user.pushStatus == 0 || user.pushStatus == 1 || user.pushStatus == 2){

                    optBtnInfo.text = '发布';
                    optBtnInfo.status = 'push';

                  }else{

                     optBtnInfo.text = '重置至未发布';
                     optBtnInfo.status = 'notIssue';
                  }

                  _this.user = user;

              }
              console.info('请求结果1:', response )
            
            } catch (error) {
              console.error('请求失败:', error)
            }

        },resetForm(){

           _this.dialogVisible = false;
            // 1. 清空 Element UI 的文件列表
            if (_this.$refs.uploadPhoto) {
              _this.$refs.uploadPhoto.clearFiles();
            }
            if (_this.$refs.baseForm) {
                // 重置表单数据和验证状态
                _this.$refs.baseForm.resetFields();
            }
            // 2. 关闭预览对话框
            _this.dialogVisible = false;
            
            // 3. 清空预览图片URL
            _this.dialogImageUrl = '';

          _this.user = {sex:'',provinceId:'',cityId:'',countyId:'',marriageStatus:'',pushStatus:'',level:'',introContent:'',photoImgPath:[]}

        },deleteImage(index){

            let userPhoto = _this.user.userPhotoList[index];
            _this.$confirm('此操作将永久删除该图片文件, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

              let param = {"userId":userPhoto.userId,"userPhotoId":userPhoto.userPhotoId}
              
              _this.$http.post('/back_bin/user/delete_image', param,function(msg){

                let user = _this.user;
               // 或者使用 this.$delete（Vue实例方法）
               _this.$delete(user.userPhotoList, index);

                if(user.userPhotoList != null && user.userPhotoList.length > 0){
                    let srcList = [];
                    for(let key in user.userPhotoList){

                      const photo = user.userPhotoList[key];
                      srcList.push(_this.imgUrl+photo.imgPath); 

                    }

                    _this.srcList = srcList;

                  }

               _this.$message({
                type: 'success',
                message: '删除成功!'
              });

              });

             
            });
             

        },optPushNotIssue(){

            let user = _this.user;
            let optBtnInfo = _this.optBtnInfo;
            _this.$confirm('确定'+optBtnInfo.text+'吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

              let param = {"userId":user.userId,"optStatus":optBtnInfo.status}
              
              _this.$http.post('/back_bin/user/opt_push_not_issue', param,function(msg){

                   

               _this.$message({
                type: 'success',
                message: optBtnInfo.text+'成功!'
              });

               _this.isOpenDrawer = false;
               _this.getPage();

              });

            });

        },openStarDrawer(row,type){

            _this.interestPageUtil.userId = row.userId;
            _this.interestPageUtil.type = type;
            _this.interestPageUtil.curPage = 1;
            _this.isOpenStarDrawer = true;
            _this.getInterestPage();
            
        },getInterestPage(){

          try {
        
            var param = _this.interestPageUtil;

             var param = {};
            param['type'] = _this.interestPageUtil.type;
            param['pageSize'] = _this.interestPageUtil.pageSize;
            param['curPager'] = _this.interestPageUtil.curPage;
            param['userId'] = _this.interestPageUtil.userId;

            _this.$http.get('/back_bin/user/get_list_user_interest_page', param,(response)=>{

            _this.interestPageUtil.total = response.data.countSum;
            _this.interestPageUtil.curPage = response.data.curPager;
            let list = response.data.list;
            if(list!=null && list.length > 0){

              for(let i=0;i<list.length;i++){

                let bean = list[i];
                //bean.createTime = _this.$com.dateConvertTime(bean.createTime);
                bean.imgHeadUrl = _this.imgUrl+bean.imgHeadUrl;

                if(bean.sex == 0){
                   bean.sex = '未知';
                }else if(bean.sex == 1){
                   bean.sex = '男生';
                }else if(bean.sex == 2){
                   bean.sex = '女生';
                }

                if(bean.marriageStatus == 0){
                   bean.marriageStatus = '未知';
                }else if(bean.marriageStatus == 1){
                   bean.marriageStatus = '单身';
                }else if(bean.marriageStatus == 2){
                   bean.marriageStatus = '未婚';
                }else if(bean.marriageStatus == 3){
                   bean.marriageStatus = '离异';
                }else if(bean.marriageStatus == 4){
                   bean.marriageStatus = '离异带娃';
                }

              }

            }
            
            _this.interestData = list;

            });
           
          } catch (error) {
            console.error('请求失败:', error)
          }


        },interestHandleSizeChange:function(val) {

            _this.interestPageUtil.pageSize = val;

        },interestHandleCurrentChange:function(val) {

            //console.log(`当前页: ${val}`);
            _this.interestPageUtil.curPage = val;
            _this.getInterestPage();

        },nextClick:function(){

            _this.interestPageUtil.curPage = _this.interestPageUtil.curPage+1;
            _this.getInterestPage();

        },prevClick:function(){

            _this.interestPageUtil.curPage = _this.interestPageUtil.curPage-1;
            _this.getInterestPage();

        }
  }
}
</script>

<style>

.fixed-image {
  width: 150px; /* 设置固定宽度 */
  height: 200px; /* 设置固定高度 */
  object-fit: cover; /* 保持宽高比，超出部分裁剪 */
}
</style>
  
 


// WEBPACK FOOTER //
// src/components/User.vue